const riot = require('riot');

riot.tag2('page-workspace-settings', '<div class="f s-full"> <div class="box-shadow" ref="sidebar" data-is="module-sidebar"></div> <div class="f fclm s-full p32"> <div class="f fclm s-full bg-white p32 rounded-4 box-shadow"> <div class="mb40" data-is="module-title-header" title="ワークスペース設定"> <yield to="right"></yield> </div> <div class="f fm mb40"><img class="block object-fit-cover s82 rounded-4 mr32" src="/images/dummy-icon.png" alt=""> <div class="w-full"> <div class="lh15 mb8">ワークスペース名</div> <div class="f fb"> <input class="max-width-372 w-full border rounded-4 py7 px8 mr40" type="text" value="Rabee"> </div> </div> </div> <div class="lh15 mb8">メンバー</div> <div class="overflow-scroll box-shadow"> <table class="w-full border-spacing-0 border-collapse-collapse"> <thead class="sticky t0 r0 l0 bg-white z1"> <tr class="fs12 lh15 text-label_low"> <th class="text-left px24 py20">ユーザー</th> <th class="text-left px24 py20">ユーザーID</th> <th class="text-left px24 py20">単価</th> <th class="text-left px24 py20">権限</th> <th class="text-left px24 py20">非表示</th> </tr> </thead> <tbody> <tr class="hover-trigger hover-bg-label_pale lh15 cursor-pointer" if="{!user.data.disabled}" each="{user in users}" data-is="item-user_" user="{user}" ondelete="{onDeleteUser}"></tr> </tbody> </table> </div> </div> </div> </div>', 'page-workspace-settings input::placeholder,[data-is="page-workspace-settings"] input::placeholder{font-size:12px}', '', function(opts) {
    this.onDeleteText = () => {
      this.refs.search.value = '';
      this.update();
    };

    this.preload = async () => {

      var users = await app.store.collection('users').fetch({ relation: true });

      return {
        users,
      };
    };

    this.onDeleteUser = async ({ user }) => {
      let result = await spat.modal.confirm('一度非表示したユーザーは元に戻すことはできません。\n本当に非表示しますか？', '削除の確認');
      if (!result) return;
      let ref = app.store.collection('users');
      ref = ref.doc(user.id);
      await ref.update({
        disabled: true,
      });
      this.update();

      this.users = this.users.filter(u => u.id !== user.id);
      this.update();
    };

    this.onOpenModalDelete = () => {
      alert('TODO 削除モーダル実装');
    };

    this.onOpenModalEdit = () => {
      alert('TODO 編集モーダル実装');
    };

    this.onOpenModalAdd = () => {
      alert('TODO メンバー追加モーダル実装');
    };

});
riot.tag2('item-user_', '<td class="f fm px24 py18 fs12"><img class="block object-fit-cover s24 circle mr8" riot-src="{opts.user.data.icon_url}" alt=""> <div>{opts.user.data.display_name}</div> </td> <td class="px24 py18 text-label_low fs12">{opts.user.data.screen_name}</td> <td class="px24 py18 fs12"></td> <td class="px24 py18 fs10"></td> <td class="px20 py18 fs10"> <button class="hover-appear w50 fw4 fs12 button_outline_primary" onclick="{onDeleteButtonClick}">削除</button> </td>', '', '', function(opts) {
    this.mixin('enableOptsEventHandler');

    this.onDeleteButtonClick = (e) => {
      this.trigger('delete', { user: e.item.user });
    };
});